module.exports = __webpack_public_path__ + "static/media/pld_logo.a6b818bf.png";